import { FC, ReactNode, useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { priceShow } from 'shared/lib/priceShow'
import { Button } from 'shared/ui/button'
import { CheckBox } from 'shared/ui/check-box'
import { MbonusLineInfo } from 'shared/ui/mbonus/mbonus-line-info'

import s from './styles.module.scss'

interface Props {
  price?: string
  isFree?: boolean
  oldPrice?: string
  bonusInfo?: string
  errorText?: string
  countPassengers?: number
  confirmComponent?: ReactNode
  onSubmit?: () => void
}

export const MplusUnactive: FC<Props> = ({
  price,
  isFree,
  oldPrice,
  errorText,
  bonusInfo,
  countPassengers,
  confirmComponent,
  onSubmit,
}) => {
  const { t } = useTranslation()

  const [isConfirmed, setIsConfirmed] = useState<boolean>(
    !Boolean(confirmComponent),
  )

  const totalPrice = Number(price || '0')

  const totalOldPrice = Number(oldPrice || '0')
  return (
    <div className={s.container}>
      {(countPassengers || 0) > 0 && price && (
        <div className={s.information}>
          <p className={s.passenger}>{t('total')}</p>

          {isFree ? (
            <p className="bold-16">{t('free')}</p>
          ) : (
            <div className={clsx('bold-16', s.price)}>
              {oldPrice && oldPrice !== price && (
                <p className={s.oldPrice}>
                  {priceShow(String(totalOldPrice))} &#8384;
                </p>
              )}

              <p>{priceShow(String(totalPrice))} &#8384;</p>
            </div>
          )}
        </div>
      )}

      {parseInt(bonusInfo || '0') > 0 ? (
        <div className={s.bonus}>
          <MbonusLineInfo
            isTransparent
            bonus={bonusInfo}
          />
        </div>
      ) : null}

      {confirmComponent && (
        <div className={s.confirmCheck}>
          <CheckBox
            isChecked={isConfirmed}
            onClick={(value) => setIsConfirmed(Boolean(value))}
          />
          {confirmComponent}
        </div>
      )}

      {errorText && <p className={(s.errorText, 'regular-14')}>{errorText}</p>}
      <div className={s.wrapperButton}>
        <Button
          onClick={onSubmit}
          disabled={!isConfirmed}
        >
          <span className={'bold-16'}>{t('continue')}</span>
        </Button>
      </div>
    </div>
  )
}
